type SectionHeadingProps = {
  kicker: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionHref?: string;
};

export default function SectionHeading({
  kicker,
  title,
  desc,
  actionLabel,
  actionHref,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3 border-b border-background-300 pb-3 md:mb-6">
      <div>
        <span className="flex items-center gap-2 text-xs font-bold tracking-[0.28em] text-primary-600">
          <span className="h-3 w-1 rounded-full bg-primary-500" aria-hidden="true"></span>
          {kicker}
        </span>
        <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {desc ? <p className="mt-1.5 max-w-2xl text-xs text-foreground-600 md:text-sm">{desc}</p> : null}
      </div>
      {actionLabel && actionHref ? (
        <a
          href={actionHref}
          className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </a>
      ) : null}
    </div>
  );
}